import React from 'react';
import { Button, Box, TextField } from '@mui/material';

/**
 * Componente que contém os botões de ação e o campo de pesquisa.
 * @param {Function} onSearchChange - Função chamada quando o texto de busca é alterado.
 * @param {Function} onCopyTable - Função chamada ao clicar no botão "Copiar Tabela".
 * @param {Function} onExportExcel - Função chamada ao clicar no botão "Exportar para Excel".
 * @param {Function} onExportPDF - Função chamada ao clicar no botão "Exportar para PDF".
 */
function TableActions({ onSearchChange, onCopyTable, onExportExcel, onExportPDF }) {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            {/* Botões de ação */}
            <Box display="flex">
                <Button
                    variant="contained"
                    onClick={onCopyTable}
                    style={{ marginRight: 8, backgroundColor: '#17a2b8', color: '#fff' }}
                >
                    Copiar Tabela
                </Button>
                <Button
                    variant="contained"
                    onClick={onExportExcel}
                    style={{ marginRight: 8, backgroundColor: '#17a2b8', color: '#fff' }}
                >
                    Exportar para Excel
                </Button>
                <Button
                    variant="contained"
                    onClick={onExportPDF}
                    style={{ backgroundColor: '#17a2b8', color: '#fff' }}
                >
                    Exportar para PDF
                </Button>
            </Box>
            {/* Campo de pesquisa */}
            <TextField
                label="Pesquisar"
                variant="outlined"
                onChange={onSearchChange}
                style={{ flexGrow: 1, maxWidth: '300px' }}
            />
        </Box>
    );
}

export default TableActions;
